import {ReportsState} from './reports-state';
export type {ReportsState} from './reports-state';
import {createFeature, createReducer, on} from '@ngrx/store';
import {ReportsActions} from './reports.actions';



export const initialReportsState: ReportsState = {
  effectiveTimeZoneId: 'UTC',
  lastLoadedLocalDate: null,
  nearExpiryError: null,
  nearExpiryItems: [],
  nearExpiryLoading: false,
  recentChanges: [],
  recentEvents: [],
  recentChangesError: null,
  recentChangesLoading: false,
};

export const reportsFeature = createFeature({
  name: 'reports',
  reducer: createReducer(
    initialReportsState,
    on(ReportsActions.accountChanged, (state) => ({
      ...initialReportsState,
      effectiveTimeZoneId: state.effectiveTimeZoneId,
    })),
    on(ReportsActions.applicationStarted, ReportsActions.effectiveTimeZoneChanged, (state, {timeZoneId}) => ({
      ...state,
      effectiveTimeZoneId: timeZoneId,
    })),
    on(ReportsActions.refreshRequested, (state) => ({
      ...state,
      nearExpiryError: null,
      nearExpiryLoading: true,
      recentChangesError: null,
      recentChangesLoading: true,
    })),
    on(ReportsActions.nearExpiryLoadSucceeded, (state, {items, localDate}) => ({
      ...state,
      lastLoadedLocalDate: localDate,
      nearExpiryError: null,
      nearExpiryItems: items,
      nearExpiryLoading: false,
    })),
    on(ReportsActions.nearExpiryLoadFailed, (state, {error}) => ({
      ...state,
      nearExpiryError: error,
      nearExpiryLoading: false,
    })),
    on(ReportsActions.recentChangesLoadSucceeded, (state, {recentChanges, recentEvents}) => ({
      ...state,
      recentChanges,
      recentEvents: recentEvents ?? [],
      recentChangesError: null,
      recentChangesLoading: false,
    })),
    on(ReportsActions.recentChangesLoadFailed, (state, {error}) => ({
      ...state,
      recentChangesError: error,
      recentChangesLoading: false,
    })),
  ),
});
